import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function AllSubjectsIllustration({
  achievementId,
  variant = 'royal',
  // Unlocks royal variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3809" data-mp="1q0z7mzl3t39z">
      
      <div className="relative w-full h-full bg-gradient-to-br from-indigo-900 via-purple-900 to-fuchsia-900 overflow-hidden" data-id="element-3810" data-mp="1urz3s2mefhbf">
        {/* Background: Golden Mandala / Symbols */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3811" data-mp="1lz5a3067gfe1">
          
          <g className="origin-center animate-[spin_40s_linear_infinite]" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3812" data-mp="172wec8liwk6d">
            
            <circle cx="100" cy="100" r="80" stroke="#FBBF24" strokeWidth="2" strokeDasharray="10 10" opacity="0.3" data-id="element-3813" data-mp="1c2sge2anu1ja" />
            
            <circle cx="100" cy="100" r="60" stroke="#FDE047" strokeWidth="1" opacity="0.2" data-id="element-3814" data-mp="9fr5ak4myh0u" />
            

            {/* Abstract subject symbols arranged in a circle */}
            {[...Array(10)].map((_, i) => {
            const angle = i * 36 * (Math.PI / 180);
            const x = 100 + 70 * Math.cos(angle);
            const y = 100 + 70 * Math.sin(angle);
            return <circle key={i} cx={x} cy={y} r="6" fill="#FBBF24" opacity="0.6" data-id="element-3815" data-mp="3mu48x2parabu" data-mpi={i} />;
          })}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3816" data-mp="4h69qy0bwliq">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3817" data-mp="3vtr9jma7cc3u">
            <DjaySpecimen look={{
            variant,
            accessory: 'scepter'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3818" data-mp="384zkv4vtmbvt" />
            
          </div>
        </div>

        {/* Foreground: Royal Confetti */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3819" data-mp="1c11n2pdnz846">
          
            <path d="M20 40 L30 45 L25 55 Z" fill="#FDE047" data-id="element-3820" data-mp="1lrwiokcsvk2a" />
            <path d="M170 30 L180 35 L175 45 Z" fill="#FDE047" data-id="element-3821" data-mp="1lr4ondyupue4" />
            <path d="M40 160 L50 165 L45 175 Z" fill="#FBBF24" data-id="element-3822" data-mp="o4xihzmwftzn" />
            <path d="M160 150 L170 155 L165 165 Z" fill="#FBBF24" data-id="element-3823" data-mp="t38x0no52so7" />

            <circle cx="50" cy="80" r="3" fill="#A78BFA" data-id="element-3824" data-mp="t3h7k8wshlw8" />
            <circle cx="150" cy="100" r="4" fill="#F472B6" data-id="element-3825" data-mp="y228ybns2bm9" />
            <circle cx="100" cy="170" r="3" fill="#38BDF8" data-id="element-3826" data-mp="y4ogibao4r4h" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}